import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { T } from "@repo/transifex";
import { Button } from "~/components";

type CollectButtonProps = {
  onSubmit: () => void;
  isSubmitting: boolean;
  disabled?: boolean;
};

export const CollectButton = ({
  onSubmit,
  isSubmitting,
  disabled
}: CollectButtonProps) => {
  return (
    <Button
      onClick={onSubmit}
      type="submit"
      disabled={disabled}
      size="xl"
      icon={faCheck}
      className="!bg-interface-neutral-6 !text-interface-accent-1"
      loading={isSubmitting}
    >
      <T _str="Confirm collection" />
    </Button>
  );
};
